var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 207,
    height: 215,
    viewBox: "0 0 207 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M204.026 103.674C204.236 118.695 204.073 134.878 203.586 151.103C204.759 166.474 204.642 181.259 202.478 193.795C200.535 204.252 195.248 211.082 186.168 213.064C176.485 212.528 162.93 207.974 145.994 200.598C129.519 194.74 112.117 189.927 94.915 186.953C78.7527 187.362 62.6566 188.447 47.527 188.81C33.4831 190.111 20.8991 188.564 11.2264 183.188C3.727 177.063 0.139468 166.498 1.29574 151.497C4.65337 135.799 11.398 117.725 19.9823 98.8733C28.4545 80.3575 37.653 61.8563 47.0804 44.9803C55.9008 29.5563 65.6093 16.7553 76.4571 8.00315C87.6246 1.59369 100.735 -0.463744 115.603 2.08143C130.774 5.60285 145.755 11.6856 159.382 19.02C172.269 24.9843 183.141 31.8163 191.229 39.5622C198.266 46.0953 202.634 54.493 204.241 65.1094C205.715 75.2618 205.503 88.1162 204.026 103.674Z",
    stroke: "#5A42ED",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector18);
export default __webpack_public_path__ + "static/media/Vector-18.da4c1d20919dec173b5a8a3661f09fe2.svg";
export { ForwardRef as ReactComponent };